import { FormikConfig, useFormik } from 'formik';
import React from 'react';
import InputControl from '../../../components/InputControl/InputControl';
import InteractiveButton from '../../../components/InteractiveButton/InteractiveButton';
import { IValueWithTime } from '../../../types/channel-types';
import SettingsItem from '../../../components/SettingItem/SettingItem';

export type SingleValueFormProps<T, K> =
  React.InputHTMLAttributes<HTMLInputElement> & {
    values: T;
    //TODO
    //ADD validation schema
    validationSchema?: FormikConfig<T>['validationSchema'];
    onSubmit: FormikConfig<T>['onSubmit'];
    label: string;
    btnText?: string;
    currentValues: IValueWithTime<K>;
    suggestion?: string;
  };

export const SingleValueForm = <T, K>(props: SingleValueFormProps<T, K>) => {
  const { values, currentValues, onSubmit, validationSchema, suggestion, ...otherProps } = props;
  const formik = useFormik({
    initialValues: values,
    validationSchema,
    onSubmit,
    enableReinitialize: true,
  });

  return (
    <form className="p-7" onSubmit={formik.handleSubmit}>
      {Object.keys(values).map((item) => {
        return (
          <SettingsItem
            key={item}
            title={otherProps?.label}
            value={String(currentValues?.value)}
            updatedAt={new Date(currentValues?.timestamp)}
            form={(
              <div className="w-full">
                <InputControl
                  label={otherProps.label}
                  type={otherProps.type}
                  name={item}
                  placeholder={otherProps.placeholder}
                  value={formik.values[item]}
                  customOnChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  showError={formik.touched[item] && formik.errors[item]}
                  errorText={formik.errors[item]}
                  suggestion={suggestion}
                />
                <InteractiveButton
                  text={otherProps.btnText ?? 'Update'}
                  submit
                  isLoading={formik.isSubmitting}
                />
              </div>
            )}
          />
        );
      })}
    </form>
  );
};
